import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {FilterKey, FILTERS} from 'search/SearchConstants';
import {TooltipWrapper} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import * as Colors from 'ui-library/Colors';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import Section from 'ui-library/menus/Section';
import SectionHeader from 'ui-library/menus/SectionHeader';

import {FilterGroup} from './FilterFormConstants';

interface FilterKeyDropdownProps {
  buttonSize: ButtonSize;
  filterGroups: Array<FilterGroup>;
  invalidMessage?: string | null;
  onChangeFilterKey: (value: FilterKey) => void;
  selectedFilterKey: FilterKey;
  disabled?: boolean;
}

function FilterKeyDropdown(props: FilterKeyDropdownProps): JSX.Element {
  const isInvalid = props.invalidMessage != null;
  return (
    <TooltipWrapper tooltipTitle={props.invalidMessage}>
      <Dropdown
        menu={
          <Menu
            height={Menu.HEIGHTS.MEDIUM}
            width={Menu.WIDTHS.FULL}
            value={props.selectedFilterKey}
            scrollable={true}
          >
            {props.filterGroups.map((filterGroup, index) => (
              <Section key={index.toString()}>
                {filterGroup.name && (
                  <SectionHeader className={css(styles.sectionHeader)}>{filterGroup.name}</SectionHeader>
                )}
                {filterGroup.filterOptions.map((filterOption) => (
                  <Option
                    key={filterOption.filterKey}
                    value={filterOption.filterKey}
                    onSelect={props.onChangeFilterKey}
                  >
                    {FILTERS[filterOption.filterKey].name}
                  </Option>
                ))}
              </Section>
            ))}
          </Menu>
        }
      >
        <Button
          buttonStyle={isInvalid ? ButtonStyle.WARNING_LIGHT : ButtonStyle.TERTIARY_BLUE_POWDER}
          fullWidth={true}
          icon={isInvalid ? <BenchlingIcon className={css(styles.buttonIcon)} icon="warning" /> : undefined}
          isDropdown={true}
          size={props.buttonSize}
          text={FILTERS[props.selectedFilterKey].name}
          dataTestAttrs={{component: 'FilterKeyDropdown', element: 'button'}}
          disabled={props.disabled}
          // Some of the filter key names are quite long. This allows the button to expand a bit to accommodate the
          // wrapped text rather than it overflowing
          growToFitContents={true}
        />
      </Dropdown>
    </TooltipWrapper>
  );
}

const styles = StyleSheet.create({
  buttonIcon: {
    color: Colors.ORANGE,
  },
  // Allow section header to grow a bit if text wraps
  sectionHeader: {
    height: 'auto',
    paddingTop: '4px',
    paddingBottom: '4px',
  },
});
export default FilterKeyDropdown;
